import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  color: #666;\n  text-align: center;\n  font-size: 1rem;\n  margin: 0;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 40px 20px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    min-height: 500px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  border: none;\n  min-height: 600px;\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    min-height: 500px;\n    overflow-y: auto;\n    overflow-x: hidden;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  padding: 0;\n  overflow: hidden;\n  min-height: 600px;\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  background: white;\n  border-radius: 50%;\n  margin-left: auto;\n  svg {\n    width: 26px;\n    height: 26px;\n    display: block;\n    path {\n      fill: #f76268;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: bold;\n  align-self: center;\n  text-align: left;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background: #f76268;\n  color: white;\n  padding: 10px 10px 10px 20px;\n  display: grid;\n  grid-template-columns: 80% 20%;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    max-width: 400px;\n    max-height: 95vh;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 98vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled, media } from "@styles";
export var Overlay = styled.div(_templateObject());
export var Modal = styled.div(_templateObject2(), media.xMediumScreen(_templateObject3()));
export var Header = styled.div(_templateObject4());
export var Title = styled.p(_templateObject5());
export var CloseButton = styled.div(_templateObject6());
export var Content = styled.div(_templateObject7(), media.xMediumScreen(_templateObject8()));
export var TrackingFrame = styled.iframe(_templateObject9(), media.xMediumScreen(_templateObject10()));
export var NoDataContainer = styled.div(_templateObject11());
export var NoDataText = styled.p(_templateObject12());